/* eslint-disable */
import MainCard from "components/MainCard";
import { useEffect, useState } from "react";
import ECharts from 'echarts-for-react';
import { useTheme } from "components/ThemeContext";

const chartDataInit = {
  tooltip: {
    trigger: 'axis',
    axisPointer: {
      type: 'shadow'
    }
  },
  legend: {
    textStyle : {
      color : '#000'
    },
  },
  xAxis : { 
    type: 'category',
    axisTick: { show: false },
  },
  yAxis : {
    type: 'value'
  },
  series: []
}

export function BarChart({barData, widthSize=600, legendColor="#fff"}) {
  const [isLoading, setIsLoading] = useState(false);
  const [options, setOptions] = useState(chartDataInit);
  const { mode } = useTheme();

  useEffect(()=>{
    if (isLoading) {
      setIsLoading(false);
    }
    if (barData) {
      let optionsCopy = {...chartDataInit};
      let chartDataCopy = JSON.parse(JSON.stringify(optionsCopy));
      chartDataCopy.xAxis.data = barData.categories;

      barData && barData.series.map(function(seris, k) {
        chartDataCopy.series.push({ name: seris.name, data: seris.data, type: 'bar', label:{ position :'inside'}, barGap: 0, emphasis: { focus: 'series' }, });
      })
      chartDataCopy.legend.textStyle.color = (mode === 'white' ? "#000" : "#fff");
      setOptions(chartDataCopy);
      setIsLoading(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[barData, isLoading, mode]);

  if (isLoading) {
    return (
      <div className="mixed-chart mixed-chart1">
          <MainCard content={false}>
            <ECharts
              option={options}
              opts={{ renderer: 'svg', width: widthSize+'px', height: '270px' }}
            />
          </MainCard>
      </div>
    )
  }
}

export default BarChart;
